import React from 'react';
import "./socialConnectors.scss";

//images
import imgsocialConnectors from "../../../assets/connectors/imgsocialConnectors.png";
import { useTranslation } from 'react-i18next';
const SocialConnectors = () => {

    const {t} = useTranslation()

    return (
        <div className="container-socialConnectors">
            <div className="img-socialConnectors">
                <img src={imgsocialConnectors} alt="" />
            </div>
            <div className="texts-socialConnectors">
                <h1>{t("connectors.social_media_connectors.title")}</h1>
                <p>{t("connectors.social_media_connectors.section_text")}</p>
                {/* <button id="btn-socialConnectors">Saiba mais</button> */}
            </div>
        </div>
    )
}

export default SocialConnectors